<template>
  <router-view></router-view>
</template>

<script>
export default {
  
}
// export default defineComponent({
//   components: {
//     RadarChartOutlined,
//     VideoCameraOutlined,
//     UploadOutlined,
//     MenuUnfoldOutlined,
//     MenuFoldOutlined,
//     LoginOutlined,
//     DownOutlined,
//     EditOutlined,
//     LogoutOutlined,
//     ShareAltOutlined,
//     SettingOutlined
//   },
//   setup() {
//     return {
//       selectedKeys: ref(['7']),
//       openKeys:ref(['sub2']),
//       collapsed: ref(false),
//       bottomCenter:'bottom',
      
//     };
//   },
//   created(){
//     console.log(this.$route.path);
//   }
  
// });
</script>


<style>

</style>
